export const statuses = {
    "transferred_to_building_account": "Transferido a la cuenta del edificio",
    "canceled_but_not_reversed": "Plan cancelado y acreditado",
    "tourist_card_success": "El programa turístico finalizó con éxito",
    "j5": "j5",
    "failed": "Ha fallado",
    "stop_plan": "Detenido",
    "skip_payment": "Pago saltado",
    "in_progress": "Activo",
    "success_pending": "Documentación de pagos exitosos",
    "pending": "Pendiente",
    "success": "Terminó con éxito",
    "unknown": "Desconocido", // go ahead and calculate it from set of related payment plan details

    "inProgress": "Plan en proceso",

    "failedOnce": "Error reciente (todavía activo)", // still active
    "stopped": "Detenido",

    "offlinePending": "Documentación de pago. Aún no se ha ajustado el banco",
    "offlineProgress": "En proceso (documentación de pago)",
    "offlineSuccess": "Documentación de pago. Habiendo sido ajustado para la banca",
    "offlineStopped": "Documentación de pago detenido",

    "success_action_notification": "Acción realizada con éxito",
    "error_action_notification": "Operación fallida",

    "pendingCollectionReport": "Pendiente",
    "depositCollectionReport": "Depósito",
};
